const home = {
  heroTitle: 'Encontre sua hospedagem perfeita em Urubici',
  heroSubtitle: 'Chalés, cabanas e pousadas na Serra Catarinense',
  searchPlaceholder: 'Para onde você quer ir?',
  checkIn: 'Check-in',
  checkOut: 'Check-out',
  guests: 'Hóspedes',
  searchButton: 'Buscar hospedagens',
  searchButtonShort: 'Buscar',
  featuredLodgings: 'Hospedagens em Destaque',
  viewAll: 'Ver todas as hospedagens',
  experiencesSection: 'Experiências',
  eventsSection: 'Eventos',
  faqTitle: 'Dúvidas frequentes',
  faqSubtitle: 'Respostas claras sobre como funciona',
  faq: {
    q1: 'Como funciona a consulta de hospedagem?',
    a1: 'Você navega pelo catálogo curado, escolhe a hospedagem e entra em contato direto via WhatsApp, telefone ou site oficial. A confirmação da reserva é feita diretamente com o estabelecimento.',
    q2: 'Os preços são atualizados em tempo real?',
    a2: 'Não. O catálogo mostra as hospedagens disponíveis. Para valores e disponibilidade exata, entre em contato direto com o estabelecimento através dos canais publicados.',
    q3: 'Posso falar com a central de reservas?',
    a3: 'Sim. Nossa central está disponível para auxiliar com dúvidas, recomendações e suporte no processo de escolha.',
    q4: 'O site é oficial da cidade?',
    a4: 'O Reserve Connect é uma plataforma integrada ao ecossistema municipal, trabalhando em parceria com hotéis locais e o portal oficial da cidade.',
  },
  centralSupport: 'Central de Reservas',
  centralSupportDesc: 'Prefere falar com um especialista? Nossa equipe está pronta para ajudar.',
  hero: {
    slide1: {
      title: 'Urubici, o inverno que você quer viver começa aqui',
      subtitle: 'Frio de verdade, serra, natureza e as melhores hospedagens curadas da região.',
      cta: 'Buscar hospedagens',
    },
    slide2: {
      title: 'Reserve com segurança e escolha com confiança',
      subtitle: 'Compare opções, aplique filtros e entre em contato direto com os estabelecimentos.',
      cta: 'Explorar opções',
    },
    slide3: {
      title: 'Urubici é estrada, serra e experiências inesquecíveis',
      subtitle: 'Point de motociclistas, natureza exuberante e alta procura nas temporadas especiais.',
      cta: 'Ver hospedagens',
    },
    imageAlt: 'Destino turístico {{index}}',
  },
  searchForm: {
    destination: 'Destino',
    guestSingular: 'hóspede',
    guestPlural: 'hóspedes',
  },
  catalogMicrocopy: 'Catálogo curado de hospedagens em Urubici. Contato direto com os estabelecimentos.',
  trust: {
    item1: { title: 'Estabelecimentos verificados', subtitle: 'Curadoria do Portal Urubici' },
    item2: { title: 'Informações atualizadas', subtitle: 'Dados do catálogo oficial' },
    item3: { title: 'Central de reservas', subtitle: 'Suporte para sua escolha' },
  },
  featured: {
    label: 'Principal',
    subtitle: 'Opções selecionadas da curadoria de Urubici',
    loadingMessage: 'Carregando hospedagens...',
    errorMessage: 'Não foi possível carregar as hospedagens.',
    noResults: 'Nenhuma hospedagem encontrada com este filtro.',
    contactAvailable: 'Contato direto disponível',
    viewDetails: 'Ver detalhes',
    filters: ['Todos', 'Hotéis', 'Pousadas', 'Casas', 'Chalés', 'Cabanas'],
  },
  eventos: {
    title: 'Eventos & Temporadas',
    subtitle: 'Planeje sua viagem para os melhores momentos em Urubici',
    card1: {
      title: 'Temporada de Inverno',
      description: 'Frio de verdade, neve ocasional e experiências únicas na serra',
      cta: 'Ver hospedagens para o inverno',
    },
    card2: {
      title: 'Encontro de Motociclistas',
      description: 'Point tradicional com estradas cênicas e estrutura completa',
      cta: 'Hospedagens ideais para motociclistas',
    },
    card3: {
      title: 'Eventos & Festivais',
      description: 'Festivais culturais, gastronômicos e celebrações locais',
      cta: 'Buscar hospedagem para eventos',
    },
    card4: {
      title: 'Temporadas de Aventura',
      description: 'Trilhas, cachoeiras e natureza exuberante o ano todo',
      cta: 'Ver hospedagens disponíveis',
    },
  },
  explore: {
    title: 'Explore Urubici',
    subtitle: 'Tudo o que você precisa saber para planejar sua viagem',
    card1: {
      title: 'O que fazer',
      description: 'Descubra atrações, passeios e experiências locais',
    },
    card2: {
      title: 'Melhor época para visitar',
      description: 'Clima, eventos e dicas de quando viajar',
    },
    card3: {
      title: 'Guia completo da cidade',
      description: 'História, cultura e informações essenciais',
    },
  },
  finalCta: {
    title: 'Pronto para viver Urubici?',
    subtitle: 'Explore nosso catálogo curado e encontre a hospedagem perfeita para sua viagem.',
    button: 'Ver todas as hospedagens',
  },
};
export default home;
